import { z } from 'zod'
import { TagType } from '../enums'

export const SEARCH_SUGGEST_MIN_QUERY_LENGTH = 2

/** GET /api/search/suggest — what the search field offers while the viewer types. */
export const searchSuggestQuerySchema = z.object({
  q: z.string().trim().min(SEARCH_SUGGEST_MIN_QUERY_LENGTH).max(100),
  lat: z.coerce.number().min(-90).max(90).optional(),
  lng: z.coerce.number().min(-180).max(180).optional(),
})

export type SearchSuggestQuery = z.infer<typeof searchSuggestQuerySchema>

export const searchSuggestTagSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  tagType: z.enum([
    TagType.CATEGORY,
    TagType.SUB_CATEGORY,
    TagType.SUB_SUB_CATEGORY,
    TagType.AMENITY,
  ]),
  parentId: z.string().uuid().nullable(),
})

export const searchSuggestEventSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  startTime: z.string(),
  coverUrl: z.string().nullable(),
  slug: z.string().optional(),
})

export const searchSuggestPlaceSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  coverUrl: z.string().nullable(),
  city: z.string().optional(),
})

export const searchSuggestPersonSchema = z.object({
  id: z.string().uuid(),
  displayName: z.string(),
  handle: z.string().nullable(),
  avatarUrl: z.string().nullable(),
})

export const searchSuggestPlanSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
})

export const searchSuggestOrganizerSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  handle: z.string(),
  avatarUrl: z.string().nullable(),
  isVerified: z.boolean(),
  followerCount: z.number().int(),
})

/** At most three of each; people and plans stay empty for anonymous viewers. */
export const searchSuggestResponseSchema = z.object({
  tags: z.array(searchSuggestTagSchema),
  events: z.array(searchSuggestEventSchema),
  places: z.array(searchSuggestPlaceSchema),
  organizers: z.array(searchSuggestOrganizerSchema),
  people: z.array(searchSuggestPersonSchema),
  plans: z.array(searchSuggestPlanSchema),
})

export type SearchSuggestResponse = z.infer<typeof searchSuggestResponseSchema>
